(function () {
    'use strict';

    angular.module('swif.reservations')
    .config(route)
    .controller('ReservationsPlanningController', ReservationsPlanningController);

    function route($routeProvider) {
        'ngInject';
        $routeProvider.when('/reservations/reservations/planning_view', {
            templateUrl: 'partials/openresa/planning.html',
            controller: 'ReservationsPlanningController',
            reloadOnSearch: false,
            resolve: {
                data: ['openresaPlanningService', function (service) {
                    return service.resolveData();
                }]
            }
        });
    }

    function ReservationsPlanningController($scope, $location, $compile, $q, $window, $uibModal, $timeout, uiCalendarConfig, swif, data, openresa, openresaHumanResourcesService) {
        'ngInject';
        console.log('init ReservationsPlanningController');
        swif.settings.page.title = 'Planning';
        $scope.currentFilter = {};
        $scope.service = openresa;
        openresa.rights.getUserAbility($scope);
        $scope.debug = $location.search().debug || false;
        $scope.collapseSites = false;
        $scope.collapseEquipments = false;
        $scope.collapseHumanResources = false;
        $scope.vocabulariesOk = false;
        $scope.panelConfig = {isOpened: false, x: 0, y: 0, bookingId: false};
        $scope.eventFilter = {
            date_start: null,
            date_end: null,
            selectedResources: []
        };
        $scope.loading = {events: {}};
        $scope.events = [];
        $scope.eventSources = [$scope.events];
        $scope.panelIsOpened = false;
        $scope.onResourceSelected = onResourceSelected;
        $scope.onHumanResourceSelected = onHumanResourceSelected;
        $scope.onClickRemoveResource = onClickRemoveResource;
        $scope.removeAllSelectedResources = removeAllSelectedResources;
        $scope.parseLocation = parseLocation;
        $scope.updateSitesSelection = updateSitesSelection;
        $scope.updateEquipmentsSelection = updateEquipmentsSelection;
        $scope.updateOfficersSelection = updateOfficersSelection;
        $scope.updateTeamsSelection = updateTeamsSelection;
        $scope.updateServiceSuppliersSelection = updateServiceSuppliersSelection;

        $scope.fullcalendar = openresa.planning.getFullcalendar();
        $scope.fullcalendar.viewRender = fullcalendarViewRender;
        $scope.fullcalendar.eventMouseout = eventMouseout;
        $scope.fullcalendar.eventMouseover = eventMouseover;
        $scope.fullcalendar.timezone = swif.user.getTimeZone();
        $scope.fullcalendar.droppable = true;
        $scope.fullcalendar.drop = fullcalendarDrop;
        $scope.fullcalendar.toggleExpand = toggleExpand;
        $scope.fullcalendar.eventDrop = fullcalendarEventDrop;
        $scope.fullcalendar.eventResize = fullcalendarEventResize;
        $scope.fullcalendar.eventClick = fullcalendarEventClick;
        $scope.fullcalendar.select = fullcalendarSelect;
        $scope.fullcalendar.eventAfterAllRender = fullcalendarEventAfterAllRender;
        $scope.fullcalendar.editable = false;
        $scope.fullcalendar.eventRender = fullcalendarEventRender;

        $scope.printPlanning = printPlanning;
        $scope.expanded = false;
        $scope.setPlanningDateFromTask = setPlanningDateFromTask;
        $scope.onDragTaskComplete = onDragTaskComplete;
        $scope.refresh = refresh;

        $scope.parseLocation();
        var defers = [];

        var type_id;
        swif.data.get('partner',  swif.user.getAuthenticatedUserData().partner_id[0]).then(function (partner){
            type_id = partner.type_id[0];

            var site_params = openresa.planning.getSiteParams(type_id);
            defers.push(swif.collections.createOrUpdate('sites', 'site', site_params)
                .then(function(collection) {
                    $scope.sites = collection;
                    $scope.updateSitesSelection();
                })
            );

            openresa.planning.loadProductColors(site_params);

            var eq_params = openresa.planning.getEquipmentParams(type_id);
            defers.push(swif.collections.createOrUpdate('equipments', 'equipment', eq_params)
                .then(function(collection) {
                    $scope.equipments = collection;
                    $scope.updateEquipmentsSelection();
                })
            );
        });

        let humanResourcesService = openresaHumanResourcesService;
        $scope.humanResources = humanResourcesService;
        $scope.officers = humanResourcesService.officers;
        $scope.teams = humanResourcesService.teams;
        $scope.serviceSuppliers = humanResourcesService.serviceSuppliers;


        $q.all(defers).then (function () {
            $scope.vocabulariesOk = true;
        });

        $scope.$watch('eventFilter', function (newV, oldV) {
            if(newV !== oldV) {
                getEvents();
            }
        }, true);

        $scope.$watchGroup(
            ['sites.items', 'equipments.items', 'officers.items', 'teams.items', 'serviceSuppliers.items'],
            function () { getEvents(); }
        );

        $scope.$watch('officers.items', function(newV, oldV) {
            if (newV !== undefined && newV.length > 0) {
                $scope.updateOfficersSelection();
            }
        });

        $scope.$watch('teams.items', function(newV, oldV) {
            if (newV !== undefined && newV.length > 0) {
                $scope.updateTeamsSelection();
            }
        });

        $scope.$watch('serviceSuppliers.items', function(newV, oldV) {
            if (newV !== undefined && newV.length > 0) {
                $scope.updateServiceSuppliersSelection();
            }
        });

        $scope.$watchGroup(['planningReservations.items', 'eventFilter.selectedResources'], function (newV, oldV) {
            // 'items' has a new reference (a new Object) when recomputed,
            // this is the only moment where a get() is performed
            // so, to trigger a new call to the backend, a reference comparison is enough
            if(newV[0] !== oldV[0] || !angular.equals(newV[1], oldV[1])) {
                _populateEvents(newV[0]);
            }
            if (!newV[0]) {
                $scope.eventSources[0] = [];
            }
        }, true);

        function updateSitesSelection() {
            if($scope.sites) {
                _.forEach($scope.sites.items, function (item) {
                    if (item) {
                        if (item.product_id) {
                            item._active = _.contains($scope.eventFilter.selectedResources, item.product_id[0]);
                        }
                    }
                });
            }
        }

        function updateEquipmentsSelection() {
            if($scope.equipments) {
                _.forEach($scope.equipments.items, function (item) {
                    item._active = _.contains($scope.eventFilter.selectedResources, item.product_product_id[0]);
                });
            }
        }

        function updateOfficersSelection() {
            if ($scope.officers) {
                _.forEach($scope.officers.items, function(item) {
                    item._active = _.contains($scope.eventFilter.selectedResources, item.id);
                });
            }
        }

        function updateTeamsSelection() {
            if ($scope.teams) {
                _.forEach($scope.teams.items, function(item) {
                    item._active = _.contains($scope.eventFilter.selectedResources, item.id);
                });
            }
        }

        function updateServiceSuppliersSelection() {
            if ($scope.serviceSuppliers) {
                _.forEach($scope.serviceSuppliers.items, function(item) {
                    item._active = _.contains($scope.eventFilter.selectedResources, item.id);
                });
            }
        }


        // if sites / equipments already exists (we already went to this view before, without refreshing browser)
        // we recompute the selectedResources param
        // @TODO: parse url to retrieve params 'week' (integer), 'year' (integer) and 'resources' (coma separated str of ids)
        function parseLocation() {
            swif.fullcalendar.parseLocation($scope.fullcalendar);

            var resources = $location.search()['calendar:resources'];
            // i use parseFloat instead of parseInt, because of signature from _.map (val, index),
            // the index val is interpreted by _.parseInt as the radix param, and returns NaN some times
            resources = _.isString(resources) ? _.map(resources.split(','), parseFloat) : [];

            if(!_.isEmpty(resources)) {
                $scope.eventFilter.selectedResources = resources;
                $scope.updateSitesSelection();
                $scope.updateEquipmentsSelection();
                $scope.updateOfficersSelection();
                $scope.updateTeamsSelection();
                $scope.updateServiceSuppliersSelection();
            }
        }


        function onResourceSelected(item, valueToUpdate) {
            item._active = !item._active;
            if (item._active && !_.contains($scope.eventFilter.selectedResources, valueToUpdate)) {
                $scope.eventFilter.selectedResources.push(valueToUpdate);
            }
            else if (!item._active && _.contains($scope.eventFilter.selectedResources, valueToUpdate)) {
                $scope.eventFilter.selectedResources = _.without($scope.eventFilter.selectedResources, valueToUpdate);
            }
            if ($scope.eventFilter.selectedResources.length > 0) {
                $location.search('calendar:resources', $scope.eventFilter.selectedResources.join(','));
            } else {
                $location.search('calendar:resources', null);
            }
        }

        function onClickRemoveResource(productId) {
            if ($scope.eventFilter) {
                $scope.eventFilter.selectedResources = _.without($scope.eventFilter.selectedResources, productId);
                $location.search('calendar:resources', $scope.eventFilter.selectedResources.join(','));
                $scope.updateSitesSelection();
                $scope.updateEquipmentsSelection();
                $scope.updateOfficersSelection();
                $scope.updateTeamsSelection();
                $scope.updateServiceSuppliersSelection();
            }
        }

        function removeAllSelectedResources() {
            $scope.eventFilter.selectedResources = [];
            $scope.updateSitesSelection();
            $scope.updateEquipmentsSelection();
            $scope.updateOfficersSelection();
            $scope.updateTeamsSelection();
            $scope.updateServiceSuppliersSelection();
            $location.search('calendar:resources', null);
        }

        function onHumanResourceSelected($value) {
            let data = $value.data;
            let type = $value.type;

            if (data == undefined || type == undefined) return;

            onResourceSelected(data, data.id);
        }

        /**
         * calendar related methods
         */
        function fullcalendarEventRender(event, element, view) {
            var time = element.find('.fc-time');
            var title = element.find('.fc-title');
            if(event.data && event.data.recurrence_id) {
                title.prepend('<i class="fa fa-repeat fa-fw"></i>');
            }
            _.forEach(event.description, function (resource) {
                title.append('<br><b>' + resource.name + '</b>');
            });
            //add more data in the content in the case of month view
            if (view.name === 'month' && event.data) {
                time.replaceWith(
                    swif.date.formatDatetime(event.data.checkin, 'HH:mm') +
                     '-' + swif.date.formatDatetime(event.data.checkout, 'HH:mm')
                );
                //TODO let the user display resources
                var r_names = [];
                _.forEach(event.data.resource_ids, function (r) {
                    r_names.push(openresa.planning.productName[r]);
                });

                title.append('<br/>' + r_names.join('<br/>'));
            }
        }

        function printPlanning() {
            var oldParams = {
                height: $scope.fullcalendar.height,
                colors: angular.copy(openresa.planning.productColor)
            };
            //set height to max
            $scope.fullcalendar.height = 'auto';
            $scope.parseLocation();
            $scope.expanded = true;
            setTimeout(function () {
                //print + revert changes + apply
                window.print();
                $scope.expanded = false;
                swif.data.replaceObj(openresa.planning.productColor, oldParams.colors);
                $scope.fullcalendar.height = oldParams.height;
                $scope.parseLocation();
                $scope.$apply();
            }, 200);
        }

        function fullcalendarEventAfterAllRender() {
            this.updateHeight();
        }

        function fullcalendarSelect(start, end) {
            start = swif.date.fixPlanningTZ(start);
            end = swif.date.fixPlanningTZ(end);
            var modalParams = {resources: $scope.eventFilter.selectedResources};
            modalParams.checkin = start.format('YYYY-MM-DD HH:mm:00');
            modalParams.checkout = end.format('YYYY-MM-DD HH:mm:00');
            //we need to fix planning tz
            var modalInstance = $uibModal.open({
                templateUrl: 'partials/openresa/planning_add_modal.html',
                controller: 'PlanningReservationModal',
                resolve: {
                    modalParams: function () {
                        return modalParams;
                    }
                }

            });
            modalInstance.result.then(function (task) {
                // $scope.planningReservations.getItems();
                // refreshCalendar();
                // refreshPlanningTasks();
            }, function () {
                // openresa.planning.purgeModel('formReservationModel');
            });
        }

        function updateBookingFromEvent(event) {
            var ret = $q.defer();
            ret.reject();
            var booking = event.data;
            if (booking) {
                // retrieve UTC dates from planning
                booking.checkin = swif.date.fixPlanningTZ(event.start).format('YYYY-MM-DD HH:mm:00');
                booking.checkout = swif.date.fixPlanningTZ(event.end).format('YYYY-MM-DD HH:mm:00');
                // prepare the values to be saved on backend
                var vals = {checkin: booking.checkin, checkout: booking.checkout};
                var lineIds = booking.reservation_line;
                // compute the one2many save values, to update dates
                // of booking_lines (they will have the same dates as the booking)
                // [ [1, ID, {}], [1, ID2, {}], ... ]
                var lineVals = _.map(lineIds, function (lineId) {
                    return [1, lineId, {checkin: booking.checkin, checkout: booking.checkout}];
                });
                vals.reservation_line = lineVals;
                /* if (!booking.recurrence_id) {
                    return swif.data.save('reservation', booking.id, vals);
                } */
                return swif.data.save('reservation', booking.id, vals);
            }
            return ret.promise;
        }

        function fullcalendarEventDrop(event){
            updateBookingFromEvent(event).then(function () {
                    swif.message.addInfo('Booking has been updated successfully');
                }
            );
        }
        function fullcalendarEventResize(event) {
            updateBookingFromEvent(event).then(function () {
                    swif.message.addInfo('Booking has been updated successfully');
                }
            );
        }

        function fullcalendarEventClick(event) {
            if (event.data) {
                if (openresa.planning.canSeeEventDetails(event.data)) {
                    var modalParams = event;
                    var modalInstance = $uibModal.open({
                        templateUrl: 'partials/openresa/planning_action_modal.html',
                        controller: 'PlanningReservationActionModal',
                        resolve: {
                            modalParams: function () {
                                return modalParams;
                            }
                        }
                    });
                    modalInstance.result.then(function (res) {
                        // the modal will be (properly) closed as soon as
                        // the form modal (booking or request one) will be
                        // submitted
                        // $scope.planningReservations.getItems();
                        // refreshCalendar();
                        // refreshPlanningTasks();
                    });
                }
            }
        }

        function _populateEvents(data) {
            $scope.eventSources[0] = _.map(
                data, openresa.planning.fromOdooEvents2Fullcalendar
            );
            _.remove($scope.eventSources[0], function (event) {
                return _.isUndefined(event);
            });
            loadSpecialDays();
        }

        function getEvents() {
            if (
                $scope.currentStart &&
                $scope.currentEnd &&
                $scope.sites &&
                $scope.equipments
            ) {
                var selectedResources = $scope.eventFilter.selectedResources || [];

                var noSelectedRessources = _.isEmpty(selectedResources)
                if (noSelectedRessources) {
                    selectedResources = [];
                    if ($scope.sites) {
                        _.forEach($scope.sites.items, function(site) {
                            selectedResources.push(site.product_id[0]);
                        });
                    }
                    if ($scope.equipments) {
                        _.forEach($scope.equipments.items, function(eqpt) {
                            selectedResources.push(eqpt.product_product_id[0]);
                        });
                    }
                    if ($scope.officers) {
                        _.forEach($scope.officers.items, function(officer) {
                            selectedResources.push(officer.id);
                        });
                    }
                    if ($scope.teams) {
                        _.forEach($scope.teams.items, function(team) {
                            selectedResources.push(team.id);
                        });
                    }
                    if ($scope.serviceSuppliers) {
                        _.forEach($scope.serviceSuppliers.items, function(serviceSupplier) {
                            selectedResources.push(serviceSupplier.id);
                        });
                    }
                }

                var params = openresa.planning.getCalendarFilter(
                    $scope.currentStart,
                    $scope.currentEnd,
                    selectedResources,
                    $scope.planningReservations,
                    noSelectedRessources
                );
                if(!$scope.planningReservations) {
                    openresa.planning.initCollection(params, {limitPerPage: 0})
                    .then(function (coll) {
                        $scope.planningReservations = coll;
                    });
                } else {
                    // collection already exists, only update its currentFilter to let fetch data by itself
                    $scope.planningReservations.currentFilter = params;
                }
            }
        }

        function fullcalendarViewRender(view) {
            var format = 'YYYY-MM-DD 00:00:00';
            var filter = angular.copy($scope.eventFilter);
            $scope.currentStart = view.start ? view.start.format(format) : undefined;
            $scope.currentEnd = view.end ? view.end.format(format) : undefined;
            if($scope.currentStart) {
                if($scope.currentStart !== filter.date_start) {
                    filter.date_start = $scope.currentStart;
                }
            }
            if($scope.currentEnd && $scope.currentEnd !== filter.date_end) {
                filter.date_end = $scope.currentEnd;
            }
            $scope.eventFilter = filter; //call getEvents
            $scope.fullcalendarView = view.name;
            swif.fullcalendar.updateLocation(view);
        }

        function loadSpecialDays() {
            $scope.eventSources[1] = [];
            swif.fullcalendar.addSpecialDays($scope.eventSources[1]);
        }


        function fullcalendarDrop(date, jsEvent, ui) {
            var resaId = parseInt(jsEvent.target.id.split('-')[1], 10);
            var droppedResa;
            _.forEach($scope.planningReservations.items, function (resa) {
                if (resa.id === resaId) {
                    droppedResa = resa;
                }
            });
            if (droppedResa) {
                droppedResa.date_start = '';
            }
        }

        function eventMouseover(event, jsEvent, view ) {
            if (!event.data) {
                return;
            }
             var same = false;
            if ($scope.panelConfig.bookingId) {
                if ($scope.panelConfig.bookingId === event.data.id) {
                    same = true;
                }
            }
            if (!same) {
                // $scope.reservationOver = event.data.id;
                $scope.getPanel = $timeout(function (eventId) {
                    $scope.panelConfig.bookingId = eventId;
                }, 500, true, event.data.id);
            }

            $scope.getPanel.then(function () {
                $scope.displayPanel = setTimeout(function () {
                    $('#panelReservationOver').removeClass('ng-hide').css({
                        position: 'absolute', top: jsEvent.pageY, left: jsEvent.pageX
                    });
                }, 500);
            });
        }

        function eventMouseout( event, jsEvent, view ) {
            if (!event.data) {
                return;
            }
            if ($scope.getPanel) {
                $timeout.cancel($scope.getPanel);
            }
            if ($scope.displayPanel) {
                $timeout.cancel($scope.displayPanel);
            }
            setTimeout(function () {
                $('#panelReservationOver').addClass('ng-hide');
            }, 500);
        }

        function toggleExpand() {
            $scope.expanded = !$scope.expanded;
        }

        function setPlanningDateFromTask(resa) {
            uiCalendarConfig.calendars.planning.fullCalendar('gotoDate', resa.date_start);
        }


        function onDragTaskComplete(data, evt){
            console.log('drag success, data:', data);
        }
        function refresh() {
            $scope.planningReservations.getItems();
            $scope.sites.getItems().then(function() {
                $scope.updateSitesSelection();
            });
            $scope.equipments.getItems().then(function() {
                $scope.updateEquipmentsSelection();
            });
        }
    }

})();
